<template>
    <div id="app" class="flex">
        <transition
            name="fade"
            mode="out-in"
        >
            <router-view />
        </transition>
    </div>
</template>

<script>
import WebFontLoader from 'webfontloader';

export default {
    /**
     * Loads TypeKit Fonts
     */
    created() {
        WebFontLoader.load({
            custom: {
                families: ['Europa:n4,n7,i4,i7'],
            },
            timeout: 2000,
        });
    },
};
</script>
